export enum RentPeriod {
    UNKNOWN = 0,
    DAY = 1,
    MONTH = 2,
    YEAR = 3
}
